module.exports = __webpack_public_path__ + "static/media/the-promised-land-desktop.7ef907dd.jpg";